// Gemeinsame Quiz-Auswertung – muss zu backend/core/quiz_eval.py passen.
const isValidIndex = (v, n) => Number.isInteger(v) && v >= 0 && v < n;

export const getCorrectIndices = (question) => {
  const options = question?.options || [];
  const n = options.length;
  const fromObjects = options
    .map((opt, i) => (opt && typeof opt === 'object' && opt.correct ? i : -1))
    .filter((i) => i >= 0);
  if (fromObjects.length > 0) return fromObjects;

  if ((question?.type || 'single') === 'multiple') {
    if (!Array.isArray(question?.correct_answers)) return [];
    return [...new Set(question.correct_answers.filter((i) => isValidIndex(i, n)))].sort((a, b) => a - b);
  }
  return isValidIndex(question?.correct_answer, n) ? [question.correct_answer] : [];
};

export const isAnswerCorrect = (question, userAnswers) => {
  const correct = getCorrectIndices(question);
  if (correct.length === 0) return false;
  const given = [...new Set((userAnswers || []).map(Number))].sort((a, b) => a - b);
  return given.length === correct.length && given.every((v, i) => v === correct[i]);
};

export const getPassingPercent = (module) => module?.passing_score_percent ?? 100;

// Mindestens X % richtig – aufgerundet, ganzzahlig (identisch zum Backend)
export const requiredCorrect = (total, percent) => Math.max(1, Math.floor((total * percent + 99) / 100));

// Fragen eines Quiz-Moduls: quiz_questions ist die Quelle, module.content nur Fallback für Altdaten
export const getQuizQuestions = (module) => {
  if (Array.isArray(module?.quiz_questions) && module.quiz_questions.length > 0) return module.quiz_questions;
  try {
    const data = typeof module?.content === 'string' ? JSON.parse(module.content) : module?.content;
    return Array.isArray(data?.questions) ? data.questions : [];
  } catch {
    return [];
  }
};
